import CommonLink from 'components_v2/CommonLink'
import React, { useEffect, useRef, useState } from 'react'

const SharedCoachInfo = ({ coach, maxHeight = '100px' }) => {
  const name = [coach?.firstName, coach?.lastName].join(' ')
  const photo_url = coach?.profilePhoto?.url
  const [readMoreNeeded, setReadMoreNeeded] = useState(false)
  const [expanded, setExpanded] = useState(false)

  const descriptionRef = useRef(null)
  const descRef = useRef(null)
  useEffect(() => {
    const el = descriptionRef.current
    const descEl = descRef.current
    if (el && descEl && descEl.scrollHeight > el.clientHeight) {
      setReadMoreNeeded(true)
    }
  }, [])

  const formatDescription = (text = '') => {
    // Escape HTML entities (equivalent to Rails' h helper)
    const escaped = String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')

    // Auto-link URLs (equivalent to Rails' auto_link_urls)
    const linked = escaped.replace(
      /(https?:\/\/[^\s<]+)/g,
      '<a href="$1" target="_blank" class="link" rel="noopener noreferrer">$1</a>'
    )

    // Convert double newlines to paragraphs (equivalent to Rails' simple_format)
    const paragraphs = linked
      .split(/\n/g)
      .filter((i) => i !== '\r')
      .map((para) => `<p>${para}</p>`)
      .join('')

    return paragraphs
  }

  const toggleExpand = (e) => {
    e.preventDefault()
    const el = descriptionRef.current
    const mainEl = descRef?.current
    if (!el) return
    if (expanded) {
      el.style.maxHeight = maxHeight
      requestAnimationFrame(() => {
        el.style.height = ''
      })
    } else {
      el.style.maxHeight = `${mainEl.scrollHeight}px`
      const onEnd = () => {
        el.style.height = 'auto'
        el.removeEventListener('transitionend', onEnd)
      }
      el.addEventListener('transitionend', onEnd)
    }
    setExpanded((prev) => !prev)
  }

  return (
    <div className='coach-info'>
      <div className='coach'>
        {coach?.softDeleted ? (
          <span>
            <img src={photo_url} alt={name} className='img-circle' />
            {name}
          </span>
        ) : (
          <CommonLink to={`/instructors/${coach?.slug}`}>
            <img src={photo_url} alt={name} className='img-circle' />
            <span className='coach-title'>{name}</span>
          </CommonLink>
        )}
      </div>

      <div
        ref={descriptionRef}
        className={`bio readmore-js-section ${
          readMoreNeeded && !expanded ? 'readmore-js-collapsed' : ''
        }`}
        style={{
          overflow: 'hidden',
          transition: 'height 0.3s ease',
          ...(!expanded ? { maxHeight } : {})
        }}
      >
        <div
          ref={descRef}
          dangerouslySetInnerHTML={{
            __html: formatDescription(coach?.bio, { maxParagraphs: 3 })
          }}
        />
      </div>
      {readMoreNeeded && (
        <a
          href='#/'
          onClick={toggleExpand}
          className='readmore-js-toggle desc-readmore'
        >
          Read {expanded ? 'Less' : 'More'}
        </a>
      )}
    </div>
  )
}

export default SharedCoachInfo
